var exports = {
  "k": "GuildDetachedBanner.module__container___YWNMZk",
  "v": "GuildDetachedBanner.module__banner___YWNMZk",
};

module.exports = exports;
